import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable @typescript-eslint/no-explicit-any */
import cx from "classnames";
import { useEffect, useState } from "react";
import { toolkitTestIds } from "../../../constants";
import Dialog from "../Dialog";
import WalletConnectFlow from "../WalletConnectFlow/WalletConnectFlow";
/**
 * WalletConnect is a user interface component for managing the wallet connection flow within a dialog.
 * It provides an interface for users to select, connect and interact with wallets in a modal dialog.
 *
 * @component
 * @param {IWalletConnectProps} props - The props for the WalletConnect component.
 * @param {II18N} props.i18n - An object containing localized text for the WalletConnectFlow component.
 * @param {boolean} props.isLoading - Whether the component is in a loading state.
 * @param {string} [props.learnMoreRoute] - The route for the "Learn More" link.
 * @param {ReactNode} props.legalDisclaimer - The legal disclaimer content to be displayed.
 * @param {(key: KnownCip30WalletId, wallet: TInitialApi) => void} props.onConnectWallet - Callback function to be called when a wallet is connected.
 * @param {() => void} props.onClose - Callback function to be called when the dialog is closed.
 * @param {boolean} props.open - Whether the dialog is open or not.
 * @param {string[]} [props.allowList] - An optional array of wallet IDs to be displayed. All other wallets will be hidden.
 * @param {string[]} [props.ignoreList] - An optional array of wallet IDs to be hidden.
 * @param {ReactNode} props.noWalletsComponent - The component to be displayed when no wallets are available.
 * @param {boolean} [props.onlyKnown] - Whether to only show known wallets.
 * @param {string} [props.suggestWalletRoute] - The route for the "Suggest Wallet" link.
 * @param {string} [props.testId="wallet-connect-dialog-container"] - The test ID used for testing.
 * @param {boolean} [props.iframe] - Whether the WalletConnectFlow component should be rendered within an iframe.
 * @param {IP2PWalletButtonProps} props.cip45 - The props for the CIP-45.
 * @param {boolean} [props.isWalletConnected] - Whether the wallet is connected or not.
 * @returns {JSX.Element} A rendered WalletConnect component.
 */
const WalletConnect = ({ i18n, isLoading, learnMoreRoute, legalDisclaimer, onConnectWallet, onClose, open, allowList, ignoreList, testId = toolkitTestIds.walletConnectDialog.container, noWalletsComponent, onlyKnown, suggestWalletRoute, iframe = false, cip45, isWalletConnected, }) => {
    const [cip45DialogOpen, setCip45DialogOpen] = useState(false);
    useEffect(() => {
        if (isWalletConnected) {
            onClose();
            setCip45DialogOpen(false);
        }
    }, [isWalletConnected]);
    return (_jsx(Dialog, { closeDialog: onClose, open: open, primitiveProps: {
            content: {
                className: cx("z-30", { invisible: cip45DialogOpen }),
            },
            overlay: {
                className: "z-30",
            },
            portal: {
                className: "opacity-0",
            },
        }, description: i18n.description, testId: testId, title: i18n.title, children: _jsx(WalletConnectFlow, { i18n: i18n, isLoading: isLoading, learnMoreRoute: learnMoreRoute, legalDisclaimer: legalDisclaimer, onConnectWallet: onConnectWallet, allowList: allowList, ignoreList: ignoreList, noWalletsComponent: noWalletsComponent, onlyKnown: onlyKnown, suggestWalletRoute: suggestWalletRoute, iframe: iframe, ...(cip45 && {
                cip45: { ...cip45, cip45DialogOpen, setCip45DialogOpen },
            }) }) }));
};
export default WalletConnect;
//# sourceMappingURL=WalletConnectDialog.js.map